export default {
  install(Vue, opts = {}) {
    Vue.prototype.$_build = (filters, orderBy, asc, andJoin) => {
      this.build(filters, orderBy, asc, andJoin)
    }

    Vue.prototype.$buildObject = (filters = {}, orderBy = null, asc = null, andJoin = true) => {
      return this.build(filters, orderBy, asc, andJoin)
    }

    Vue.prototype.$buildString = (filters = {}, orderBy = null, asc = null, andJoin = true) => {
      const queryObj = this._build(filters, orderBy, asc, andJoin)
      const keys = Object.keys(queryObj)
      let queryStr = ''

      for (let i = 0; i < keys.length; i++) {
        if (queryStr !== '') {
          queryStr += '&'
        }
        queryStr += `${keys[i]}=${queryObj[keys[i]]}`
      }

      return queryStr
    }

    Vue.prototype.$parse = router => {
      const filters = {}

      const types = {}
      if (router.query.searchFields) {
        const searchFields = router.query.searchFields.split(';')
        for (let i = 0; i < searchFields.length; i++) {
          const pairs = searchFields[i].split(':')
          types[pairs[0]] = pairs[1] + (typeof pairs[2] !== 'undefined' ? `:${pairs[2]}` : '')
        }
      }

      if (router.query.search) {
        const search = router.query.search.split(';')
        for (let i = 0; i < search.length; i++) {
          const pairs = search[i].split(':')
          if (pairs.length === 2) {
            filters[pairs[0]] = {
              type: types[pairs[0]],
              value: pairs[1],
            }
          }
        }
      }

      return filters
    }
  },

  build(filters, orderBy, asc, andJoin) {
    const query = {}
    let search = ''
    let searchFields = ''

    // Set filters
    const keys = Object.keys(filters)
    for (let i = 0; i < keys.length; i++) {
      const name = keys[i]
      const filter = filters[name]

      if (filter.value === undefined || filter.value === 'undefined' || filter.value === '') {
        continue
      }

      if (search !== '') {
        search += ';'
      }

      if (searchFields !== '') {
        searchFields += ';'
      }

      search += `${name}:${filter.value}`
      searchFields += `${name}:${filter.type}`
    }

    if (search !== '') {
      query.search = search
    }

    if (searchFields !== '') {
      query.searchFields = searchFields
    }

    // Set order
    if (orderBy !== null) {
      query.orderBy = orderBy
    }

    if (asc === true) {
      query.sortedBy = 'asc'
    } else if (asc === false) {
      query.sortedBy = 'desc'
    }

    if (andJoin) {
      query.searchJoin = 'and'
    }

    return query
  },
}
